<template>
  <div class="dashboard">
    <div class="content-cards-header">
      <div class="cards-header">
        <div class="card-info-wrap">
          <div class="icon-wrapper">
            <img class="cash" :src="ReceiptOne" />
          </div>
          <div class="text-wrapper">
            <span class="title-cards">Receitas Emitidas (Mês)</span>
            <b-spinner v-if="spinGeneral" small></b-spinner>
            <span class="value-cards" v-else>{{ countFinalizado }}</span>
          </div>
        </div>
        <div class="footer-cards">
          <span class="trend up">↑</span>
          Uma média de {{ mediaDia }}
          {{ mediaDia > 1 ? "receitas" : "receita" }} por dia!
        </div>
      </div>

      <div class="cards-header">
        <div class="card-info-wrap">
          <div class="icon-wrapper">
            <b-icon-calendar2-event class="cash" />
          </div>
          <div class="text-wrapper">
            <span class="title-cards">Receitas Emitidas (Hoje)</span>
            <b-spinner v-if="spinGeneral" small></b-spinner>
            <span class="value-cards" v-else>{{ countHoje }}</span>
          </div>
        </div>
        <div class="footer-cards">
          <span class="trend neutral"></span>
          {{
            countHoje >= mediaDia
              ? "Você superou a média!"
              : "Abaixo da média diária"
          }}
        </div>
      </div>

      <div class="cards-header">
        <div class="card-info-wrap">
          <div class="icon-wrapper">
            <img class="cash" :src="Seeds" />
          </div>
          <div class="text-wrapper">
            <span class="title-cards">Produtos</span>
            <b-spinner v-if="spinGeneral" small></b-spinner>
            <span class="value-cards" v-else>{{ totalProdutos }}</span>
          </div>
        </div>
        <div class="footer-cards">Indicações deste mês</div>
      </div>

      <div class="cards-header">
        <div class="card-info-wrap">
          <div class="icon-wrapper">
            <b-icon-people-fill class="cash" />
          </div>
          <div class="text-wrapper">
            <span class="title-cards">Clientes</span>
            <b-spinner v-if="spinGeneral" small></b-spinner>
            <span class="value-cards" v-else>{{ totalClientes }}</span>
          </div>
        </div>
        <div class="footer-cards">
          <span class="trend up">↑</span> Só neste mês foram
          {{ novosClientes }} novos clientes!
        </div>
      </div>
    </div>

    <div class="content-updates-section">
      <div class="updates-container">
        <div class="head-updates">
          <div class="updates-title-group">
            <b-icon-arrow-repeat class="update-icon" />
            <div class="updates-text">
              <h4>Últimas Atualizações</h4>
              <p :class="{ 'updates-today-subtitle': !loading && atualizacoesHoje.length }">
                <template v-if="!loading && atualizacoesHoje.length">
                  {{ atualizacoesHoje.length }}
                  {{ atualizacoesHoje.length === 1 ? "atualização" : "atualizações" }} hoje
                </template>
                <template v-else>Novidades e melhorias do sistema.</template>
              </p>
            </div>
          </div>

          <div class="updates-actions">
            <span v-if="totalPaginasAtualizacoes > 1" class="updates-page-indicator">
              {{ paginaAtualizacao + 1 }} / {{ totalPaginasAtualizacoes }}
            </span>
            <button
              v-if="totalPaginasAtualizacoes > 1"
              @click="mudarPagina(-1)"
              class="nav-arrow-btn"
              aria-label="Atualizações anteriores"
            >
              <b-icon-chevron-left />
            </button>
            <button
              v-if="totalPaginasAtualizacoes > 1"
              @click="mudarPagina(1)"
              class="nav-arrow-btn"
              aria-label="Próximas atualizações"
            >
              <b-icon-chevron-right />
            </button>
            <button class="contentSideBtn" v-b-modal.modal-all-atualizacao>
              Ver todas atualizações <b-icon-chevron-right />
            </button>
          </div>
        </div>

        <div class="updates-carousel" aria-live="off">
          <transition name="updates-fade">
            <div
              :key="`${dataAtual}-${atualizacoesHoje.length}-${paginaAtualizacao}`"
              class="cards-center-update"
            >
              <div
                v-for="(item, index) in atualizacoesExibidas"
                :key="index"
                :class="['cards-update', { 'card-update-today': item.data && item.data.slice(0, 10) === dataAtual }]"
              >
                <div class="head-card-update">
                  <span class="title-update"
                    ><span class="dot"></span> {{ formatarData(item.data) }}</span
                  >
                  <span
                    :class="['subtitle-update', obterEstiloTipo(item.tipo).classe]"
                  >
                    {{ obterEstiloTipo(item.tipo).texto }}
                  </span>
                </div>
                <div class="body-cards-update">
                  {{ item.textoAtualizacao }}
                </div>
                <div class="footer-card-update">
                  <a href="#" @click.prevent="abrirModalAtualizacao(item)">
                    Saiba mais <b-icon-chevron-right font-scale="0.8" />
                  </a>
                </div>
              </div>
              <div v-if="loading || (!updates.length && !erroAtualizacoes)" class="loading-updates">
                {{ loading ? "Carregando atualizações..." : "Nenhuma atualização disponível." }}
              </div>
              <div v-if="erroAtualizacoes" class="loading-updates">
                Não foi possível carregar as atualizações.
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <div class="content-charts-section">
      <div class="cards-chart">
        <div class="chart-header">
          <img class="chart-title-icon" :src="Corn" />
          <span class="title-cards-center"
            >Top 5 - Culturas preescritas (mês)</span
          >
        </div>
        <div v-show="spinGeneral" class="loader-container">
          <b-spinner></b-spinner>
        </div>
        <div
          v-show="!spinGeneral"
          ref="chartCultura"
          style="width: 100%; height: 250px"
        ></div>
        <div class="chart-footer-link">
          <a @click="printCulture"
            >Ver relatório completo <b-icon-chevron-right font-scale="0.8"
          /></a>
        </div>
      </div>

      <div class="cards-chart">
        <div class="chart-header">
          <img class="chart-title-icon" :src="Spray" />
          <span class="title-cards-center"
            >Ingredientes Ativos mais vendidos (mês)</span
          >
        </div>
        <div v-show="spinGeneral" class="loader-container">
          <b-spinner></b-spinner>
        </div>
        <div
          v-show="!spinGeneral"
          ref="chartIngrediente"
          style="width: 100%; height: 250px"
        ></div>
        <div class="chart-footer-link">
          <a @click="printIngrid"
            >Ver relatório completo <b-icon-chevron-right font-scale="0.8"
          /></a>
        </div>
      </div>
    </div>

    <div class="content-weather-section">
      <div class="weather-banner" :class="weatherClass">
        <div v-if="weather.main" class="weather-content-new">
          <div class="weather-left">
            <div class="weather-location-info">
              <span class="city">{{ weather.name }}</span>
              <span class="date">{{ formattedDate }}</span>
            </div>

            <div class="weather-temp-block">
              <span class="temp-value-new"
                >{{ Math.round(weather.main.temp) }}°C</span
              >
              <div class="weather-desc-block">
                <img
                  :src="`https://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`"
                  alt="Weather icon"
                  class="weather-icon-new"
                />
                <span class="temp-desc-new">{{
                  weather.weather[0].description
                }}</span>
              </div>
            </div>
          </div>

          <div class="weather-right">
            <div class="detail-item">
              <b-icon-thermometer-half
                class="weather-detail-icon"
              ></b-icon-thermometer-half>
              <div class="detail-text">
                <span class="detail-val"
                  >{{ Math.round(weather.main.temp_max) }}°C</span
                >
                <span class="detail-label">Máxima</span>
              </div>
            </div>
            <div class="detail-item">
              <b-icon-wind class="weather-detail-icon"></b-icon-wind>
              <div class="detail-text">
                <span class="detail-val">{{ weather.wind.speed }} km/h</span>
                <span class="detail-label">Vento</span>
              </div>
            </div>
            <div class="detail-item">
              <b-icon-droplet class="weather-detail-icon"></b-icon-droplet>
              <div class="detail-text">
                <span class="detail-val">{{ weather.main.humidity }}%</span>
                <span class="detail-label">Umidade do ar</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="weather-loading">
          <p>{{ weatherMessage }}</p>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-detalhes-atualizacao"
      centered
      hide-header
      hide-footer
      modal-class="update-details-modal"
      title="Detalhes da atualização"
    >
      <div v-if="updateSelecionada" class="update-details">
        <div class="update-details-head">
          <div class="update-details-topline">
            <span class="update-details-eyebrow">NOVIDADES DO SISTEMA</span>
            <button
              type="button"
              class="update-details-close"
              aria-label="Fechar detalhes"
              @click="$bvModal.hide('modal-detalhes-atualizacao')"
            >
              <b-icon-x font-scale="1.4" />
            </button>
          </div>
          <h2>Detalhes da atualização</h2>
          <div class="update-details-meta">
            <span class="update-details-date">
              <b-icon-calendar2-event aria-hidden="true" />
              {{ formatarData(updateSelecionada.data) }}
            </span>
            <span :class="['subtitle-update', obterEstiloTipo(updateSelecionada.tipo).classe]">
              {{ obterEstiloTipo(updateSelecionada.tipo).texto }}
            </span>
          </div>
        </div>
        <div class="update-details-content">
          <p>{{ updateSelecionada.textoAtualizacao }}</p>
        </div>
        <div class="update-details-actions">
          <button type="button" @click="$bvModal.hide('modal-detalhes-atualizacao')">
            Entendi <b-icon-check2 aria-hidden="true" />
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalterms"
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
      title="Terms"
    >
      <div class="contentTerms">
        <div class="titleTerms">Termos & Condições</div>
        <img class="imgTerms" loading="lazy" :src="termsLogo" />
        <div class="textTerms">
          <p>
            Para continuar, por favor, aceite os nossos termos e condições.
          </p>
          <p>
            É crucial que você os leia e compreenda antes de prosseguir com o
            uso dos nossos serviços. Para acessar o documento completo
            contendo todas as cláusulas
            <a
              class="linkPdf"
              href="https://contratos-gerais.s3.sa-east-1.amazonaws.com/contratoWinfit.pdf"
              target="_blank"
              >clique aqui.</a
            >
          </p>
          <div class="checkbox-wrapper-46">
            <input
              type="checkbox"
              v-model="termsAccepted"
              id="cbx-46"
              class="inp-cbx"
            />
            <label for="cbx-46" class="cbx"
              ><span>
                <svg viewBox="0 0 12 10" height="10px" width="12px">
                  <polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg></span>
              <span class="checkbox">Concordo com os termos e condições.</span>
            </label>
          </div>
        </div>
        <div class="btnModalTerms">
          <button
            class="btnContent"
            @click="updateTerms(termsAccepted)"
            :disabled="!termsAccepted"
          >
            Confirmar
          </button>
          <button
            class="btnContent"
            style="background: whitesmoke; color: black"
            @click="$bvModal.hide('modalterms')"
          >
            Pergunte-me depois
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-all-atualizacao" centered hide-footer>
      <div v-if="moreUpdates">
        <div class="cards-modal-update">
          <div
            v-for="(item, index) in moreUpdates"
            :key="index"
            class="cards-update"
          >
            <div class="head-card-update">
              <span class="title-update"
                ><span class="dot"></span> {{ formatarData(item.data) }}</span
              >
              <span
                :class="['subtitle-update', obterEstiloTipo(item.tipo).classe]"
              >
                {{ obterEstiloTipo(item.tipo).texto }}
              </span>
            </div>
            <div class="body-cards-update">
              {{ item.textoAtualizacao }}
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import * as echarts from "echarts";
import axios from "axios";
import api from "../../services/axios";
import { DateTime } from "luxon";
import { mapState } from "vuex";

import Cash from "../../assets/dash-coin.svg";
import Recepit from "../../assets/dash-receipt.svg";
import Fiscal from "../../assets/dash-fiscal.svg";
import Group from "../../assets/dash-group.svg";
import Chart from "../../assets/dash-chart.svg";
import Mega from "../../assets/dash-mega.svg";

import Corn from "../../assets/corn.svg";
import Grain from "../../assets/grain.svg";
import ReceiptOne from "../../assets/receiptone.svg";
import Seeds from "../../assets/seeds.svg";
import Spray from "../../assets/spray.svg";
import { printDashboard } from "../../reports/Dashboard";
import winfitLogo from "../../assets/Logo-Sem-Fundo-WINFIT-AGRO.png";
import serviceGestao from "../../services/serviceGestao";

export default {
  data() {
    return {
      Cash: Cash,
      Recepit: Recepit,
      Fiscal: Fiscal,
      Group: Group,
      Chart: Chart,
      Mega: Mega,
      Corn: Corn,
      Grain: Grain,
      ReceiptOne: ReceiptOne,
      Seeds: Seeds,
      Spray: Spray,
      termsLogo: winfitLogo,
      weather: {},
      weatherMessage: "Carregando previsão do tempo...",
      apiKey: "8ebfee51658e4df7b5ab27454d460709",
      formattedDate: this.getFormattedDate(),
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      countFinalizado: 0,
      countHoje: 0,
      totalProdutos: 0,
      totalClientes: 0,
      novosClientes: 0,
      mediaDia: 0,
      spinGeneral: false,
      topCulturas: [],
      topIngredientes: [],
      charts: {
        cultura: null,
        ingrediente: null,
      },
      updates: [],
      loading: false,
      erroAtualizacoes: false,
      paginaAtualizacao: 0,
      intervaloRotacao: null,
      dataAtual: DateTime.local().toISODate(),
      updateSelecionada: null,
      termsAccepted: false,
      moreUpdates: [],
    };
  },
  methods: {
    abrirModalAtualizacao(item) {
      this.updateSelecionada = item;
      this.$bvModal.show("modal-detalhes-atualizacao");
    },
    async findUpdate() {
      try {
        this.loading = true;
        this.erroAtualizacoes = false;
        const { data } = await api.get("/compendio/updates-report?limit=40");
        this.updates = Array.isArray(data.data) ? data.data : [];
        this.moreUpdates = this.updates;
        this.paginaAtualizacao = 0;
        this.iniciarRotacao();
      } catch (error) {
        this.erroAtualizacoes = true;
        this.$toast.open({
          message: "Ocorreu um erro ao buscar atualizações",
          type: "info",
        });
      } finally {
        this.loading = false;
      }
    },
    formatarData(dataIso) {
      if (!dataIso) return "";
      const [ano, mes, dia] = dataIso.split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    mudarPagina(direcao) {
      this.paginaAtualizacao =
        (this.paginaAtualizacao + direcao + this.totalPaginasAtualizacoes) %
        this.totalPaginasAtualizacoes;
      this.iniciarRotacao();
    },
    pausarRotacao() {
      clearInterval(this.intervaloRotacao);
      this.intervaloRotacao = null;
    },
    iniciarRotacao() {
      this.pausarRotacao();
      if (this.totalPaginasAtualizacoes > 1) {
        this.intervaloRotacao = setInterval(() => {
          const hoje = DateTime.local().toISODate();
          if (hoje !== this.dataAtual) {
            this.dataAtual = hoje;
            this.paginaAtualizacao = 0;
            this.iniciarRotacao();
            return;
          }
          this.paginaAtualizacao =
            (this.paginaAtualizacao + 1) % this.totalPaginasAtualizacoes;
        }, 13000);
      }
    },
    obterEstiloTipo(tipo) {
      const mapeamento = {
        A: { texto: "Alteração", classe: "tipo-alteracao" },
        I: { texto: "Inclusão", classe: "tipo-inclusao" },
        E: { texto: "Exclusão", classe: "tipo-exclusao" },
      };

      return (
        mapeamento[tipo] || { texto: "Atualização", classe: "tipo-alteracao" }
      );
    },
    getWeather(lat, lon) {
      const lang = "pt_br";
      const units = "metric";
      const url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${this.apiKey}&units=${units}&lang=${lang}`;

      axios
        .get(url)
        .then((response) => {
          this.weather = response.data;
        })
        .catch(() => {
          this.weatherMessage = "Não foi possível obter a previsão do tempo.";
        });
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.getWeather(
              position.coords.latitude,
              position.coords.longitude
            );
          },
          () => {
            this.weatherMessage = "Acesso à localização negado.";
            this.getWeather(-15.7801, -47.9292);
          }
        );
      } else {
        this.weatherMessage = "Geolocalização não suportada.";
      }
    },
    getFormattedDate() {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return new Date().toLocaleDateString("pt-BR", options);
    },
    async getReceipts() {
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
      try {
        this.spinGeneral = true;
        const { data } = await api.get(
          `/sales/count/status?q=${this.textPesquisa}&type=${this.type}&startDate=${this.startDate}&endDate=${this.endDate}&typeSale=Receita`
        );

        if (data) {
          this.countFinalizado = data.countFinalizado;
          this.countHoje = data.countHoje;
          this.totalProdutos = data.totalProdutos;
          this.totalClientes = data.totalClientes;
          this.novosClientes = data.novosClientes;
          this.topCulturas = data.topCulturas;
          this.topIngredientes = data.topIngredientes;
          const diasPassados = DateTime.local().day;
          const divisao = this.countFinalizado / diasPassados;
          this.mediaDia = divisao < 1 ? 1 : Math.round(divisao);
          this.$nextTick(() => {
            this.renderCharts();
            setTimeout(() => {
              this.charts.cultura?.resize();
              this.charts.ingrediente?.resize();
            }, 100);
          });
        }
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar informações",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    renderCharts() {
      if (!this.charts.cultura) {
        this.charts.cultura = echarts.init(this.$refs.chartCultura);
      }

      const optionCultura = {
        grid: {
          top: "10%",
          left: "3%",
          right: "10%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: { type: "value", show: false },
        yAxis: {
          type: "category",
          data: this.topCulturas.map((i) => i.nome),
          inverse: true,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            fontSize: 12,
            fontWeight: "bold",
          },
        },
        series: [
          {
            data: this.topCulturas.map((i) => i.total),
            type: "bar",
            barWidth: "40%",
            label: {
              show: true,
              position: "right",
              formatter: "{c}",
              color: "#333",
              fontWeight: "bold",
            },
            itemStyle: {
              color: "#2e7d32",
              borderRadius: [0, 4, 4, 0],
            },
          },
        ],
      };
      this.charts.cultura.setOption(optionCultura);

      if (!this.charts.ingrediente) {
        this.charts.ingrediente = echarts.init(this.$refs.chartIngrediente);
      }

      const optionIngrediente = {
        tooltip: { trigger: "item" },
        legend: {
          orient: "vertical",
          right: "5%",
          top: "center",
          type: "scroll",
          textStyle: { fontSize: 11, color: "#555" },
          icon: "circle",
        },
        series: [
          {
            name: "Ingredientes",
            type: "pie",
            radius: ["50%", "80%"],
            center: ["35%", "50%"],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 4,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: { show: false },
            data: this.topIngredientes.map((i) => ({
              value: i.total,
              name: i.nome,
            })),
          },
        ],
      };
      this.charts.ingrediente.setOption(optionIngrediente);
    },
    printIngrid() {
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
      printDashboard("ingrediente", this.startDate, this.endDate);
    },
    printCulture() {
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
      printDashboard("cultura", this.startDate, this.endDate);
    },
    async updateTerms(contract) {
      try {
        const token = localStorage.getItem("token");
        await serviceGestao.updateTerms(token, contract);
        this.$bvModal.hide("modalterms");
        this.$store.commit("DATA_CONTRACT", contract);
        this.$toast.open({
          message: "Contrato atualizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: error,
          type: "info",
        });
      }
    },
    handleDataContractChange() {
      if (this.dataContract === false) {
        this.$bvModal.show("modalterms");
      } else {
        this.$bvModal.hide("modalterms");
      }
    },
  },
  created() {
    this.getLocation();
    this.getReceipts();
    this.findUpdate();
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.charts.cultura?.resize();
      this.charts.ingrediente?.resize();
    });
    this.handleDataContractChange();
  },
  beforeDestroy() {
    this.pausarRotacao();
  },
  computed: {
    ...mapState(["dataContract"]),
    atualizacoesHoje() {
      return this.updates.filter(
        (item) => item.data && item.data.slice(0, 10) === this.dataAtual
      );
    },
    listaAtualizacoes() {
      return [...this.updates].sort((a, b) => {
        const aHoje = Boolean(a.data && a.data.slice(0, 10) === this.dataAtual);
        const bHoje = Boolean(b.data && b.data.slice(0, 10) === this.dataAtual);
        if (aHoje !== bHoje) return aHoje ? -1 : 1;
        return (b.data || "").localeCompare(a.data || "");
      });
    },
    totalPaginasAtualizacoes() {
      return Math.ceil(this.listaAtualizacoes.length / 4);
    },
    atualizacoesExibidas() {
      return this.listaAtualizacoes.slice(
        this.paginaAtualizacao * 4,
        (this.paginaAtualizacao + 1) * 4
      );
    },
    weatherClass() {
      if (!this.weather.weather) return "weather-default";

      const condition = this.weather.weather[0].main.toLowerCase();
      const icon = this.weather.weather[0].icon;

      if (condition.includes("clear")) {
        return icon.includes("d") ? "weather-clear-day" : "weather-clear-night";
      }
      if (condition.includes("clouds")) {
        return icon.includes("d")
          ? "weather-clouds-day"
          : "weather-clouds-night";
      }
      if (condition.includes("rain") || condition.includes("drizzle")) {
        return "weather-rain";
      }
      if (condition.includes("thunderstorm")) {
        return "weather-thunderstorm";
      }
      if (condition.includes("snow")) {
        return "weather-snow";
      }
      if (condition.includes("mist") || condition.includes("fog")) {
        return "weather-mist";
      }
      return "weather-default";
    },
  },
  watch: {
    dataContract() {
      this.handleDataContractChange();
    },
  },
};
</script>

<style scoped>
.dashboard {
  width: 100%;
  height: auto;
  margin: 60px 0 20px 40px;
  padding: 0 20px 0 50px;
  background-color: #f8f9fa;
  font-family: "Inter", sans-serif;
}

.content-cards-header {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 10px;
}

.cards-header {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-info-wrap {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

.icon-wrapper {
  background-color: #e8f5e9;
  border-radius: 10px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper.grey-icon {
  background-color: #f1f3f4;
}

.cash {
  width: 24px;
  height: 24px;
  color: #006b61;
}

.text-wrapper {
  display: flex;
  flex-direction: column;
}

.title-cards {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
  margin-bottom: 5px;
}

.value-cards {
  font-size: 24px;
  font-weight: 700;
  color: #212529;
  line-height: 1;
}

.footer-cards {
  font-size: 12px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 5px;
}

.trend.up {
  color: #2e7d32;
  font-weight: bold;
  font-size: 16px;
}
.trend.neutral {
  color: #adb5bd;
  font-weight: bold;
}

.content-updates-section {
  margin-bottom: 10px;
}

.updates-container {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  padding: 15px;
}

.updates-page-indicator {
  color: #6c757d;
  font-size: 12px;
}

.head-updates {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.updates-title-group {
  display: flex;
  align-items: center;
  gap: 15px;
}

.update-icon {
  color: #2e7d32;
  width: 24px;
  height: 24px;
}

.updates-text h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #212529;
}

.updates-text p {
  margin: 0;
  font-size: 12px;
  color: #6c757d;
}

.updates-text .updates-today-subtitle {
  color: #2e7d32;
  font-weight: 600;
}

.contentSideBtn {
  background: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 15px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #2e7d32;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 5px;
}

.contentSideBtn:hover {
  background-color: #f8f9fa;
}

.updates-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-arrow-btn {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #2e7d32;
  transition: all 0.2s;
}

.nav-arrow-btn:hover {
  background-color: #f8f9fa;
  border-color: #2e7d32;
}

.cards-modal-update {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.updates-carousel {
  position: relative;
}

.updates-fade-enter-active,
.updates-fade-leave-active {
  transition: opacity 0.45s ease, transform 0.45s ease;
}

.updates-fade-enter {
  opacity: 0;
  transform: translateX(16px);
}

.updates-fade-leave-to {
  opacity: 0;
  transform: translateX(-16px);
}

.updates-fade-leave-active {
  position: absolute;
  width: 100%;
  pointer-events: none;
}

.cards-center-update {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  padding-bottom: 5px;
}

.cards-update {
  min-width: 0;
  height: 200px;
  background-color: #ffffff;
  border: 1px solid #eaedf1;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.cards-center-update .card-update-today {
  border-color: #a5d6a7;
  background: #fbfefb;
}

@media (prefers-reduced-motion: reduce) {
  .updates-fade-enter-active,
  .updates-fade-leave-active {
    transition: none;
  }
}

.head-card-update {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-update {
  font-size: 11px;
  font-weight: 600;
  color: #2e7d32;
  padding: 4px 10px;
  background: #e1f5f2;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.title-update .dot {
  width: 6px;
  height: 6px;
  background-color: #2e7d32;
  border-radius: 50%;
  display: inline-block;
}

.subtitle-update {
  font-size: 11px;
  font-weight: 600;
  color: #1976d2;
  background-color: #e3f2fd;
  padding: 4px 10px;
  border-radius: 12px;
}
.tipo-alteracao {
  color: #1976d2;
  background-color: #e3f2fd;
}
.rowSupplier {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 2px;
  text-align: center;
  height: 40px;
  padding: 0 5px;
  gap: 10px;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.tipo-inclusao {
  color: #b78103;
  background-color: #fffde7;
  border: 1px solid #fff59d;
}

.tipo-exclusao {
  color: #c62828;
  background-color: #ffebee;
}

.body-cards-update {
  font-size: 12px;
  color: #495057;
  line-height: 1.5;
  margin-top: 10px;
  margin-bottom: auto;
  display: -webkit-box;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.footer-card-update {
  margin-top: 10px;
  border-top: 1px solid #f1f3f4;
  padding-top: 10px;
}

.footer-card-update a {
  font-size: 12px;
  color: #1976d2;
  text-decoration: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.loading-updates {
  font-size: 12px;
  color: #6c757d;
  padding: 20px;
}

.update-details {
  overflow: hidden;
  border-radius: 18px;
  background: #ffffff;
}

.update-details-head {
  padding: 16px 20px 15px;
  background: linear-gradient(135deg, #eff9f3 0%, #ffffff 90%);
  border-bottom: 1px solid #e8f1eb;
}

.update-details-topline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.update-details-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border: 0;
  border-radius: 50%;
  background: #ffffff;
  color: #63756a;
  cursor: pointer;
}

.update-details-close:hover {
  color: #1b6848;
  background: #dcf2e4;
}

.update-details-eyebrow {
  color: #2e7d32;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
}

.update-details-head h2 {
  margin: 2px 0 10px;
  color: #1c3025;
  font-size: 18px;
  font-weight: 700;
}

.update-details-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.update-details-date {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  color: #426451;
  background: #e2f1e8;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.update-details-content {
  padding: 18px 20px 10px;
  max-height: 45vh;
  overflow-y: auto;
}

.update-details-content p {
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  color: #495b50;
  font-size: 14px;
  line-height: 1.75;
}

.update-details-actions {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px 16px;
}

.update-details-actions button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 9px;
  padding: 9px 16px;
  background: #2e7d32;
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.update-details-actions button:hover {
  background: #1b5e20;
}

.update-details-close:focus-visible,
.update-details-actions button:focus-visible {
  outline: 2px solid #2e7d32;
  outline-offset: 2px;
}

.content-charts-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 15px;
}

.cards-chart {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  padding: 20px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.chart-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f1f3f4;
}

.chart-title-icon {
  width: 20px;
  height: 20px;
}

.title-cards-center {
  font-size: 14px;
  font-weight: 600;
  color: #212529;
}

.loader-container {
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-footer-link {
  text-align: right;
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.chart-footer-link a {
  padding: 3px 10px;
  font-size: 12px;
  color: #2e7d32;
  border: 1px solid #2e7d32;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  cursor: pointer;
}

.content-weather-section {
  margin-bottom: 40px;
}

.weather-banner {
  background: #006b61;
  border-radius: 12px;
  color: white;
  padding: 20px 30px;
}
.weather-default {
  background: linear-gradient(to top, #6a85b6 0%, #bac8e0 100%);
}
.weather-clear-day {
  background: linear-gradient(to top, #2980b9, #6dd5fa, #ffffff);
}
.weather-clear-night {
  background: linear-gradient(to top, #0f2027, #203a43, #2c5364);
}
.weather-clouds-day {
  background: linear-gradient(to top, #bdc3c7, #2c3e50);
}
.weather-clouds-night {
  background: linear-gradient(to top, #304352, #d7d2cc);
}
.weather-rain {
  background: linear-gradient(to top, #3a6073, #16222a);
}
.weather-thunderstorm {
  background: linear-gradient(to top, #141e30, #243b55);
}
.weather-snow {
  background: linear-gradient(to top, #e6dada, #274046);
}
.weather-mist {
  background: linear-gradient(to top, #757f9a, #d7dde8);
}
.weather-content-new {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.weather-left {
  display: flex;
  gap: 50px;
  align-items: center;
}

.weather-location-info {
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  padding-right: 30px;
}

.weather-location-info .city {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
}

.weather-location-info .date {
  font-size: 13px;
  opacity: 0.8;
  text-transform: capitalize;
}

.weather-temp-block {
  display: flex;
  align-items: center;
  gap: 15px;
}

.temp-value-new {
  font-size: 42px;
  font-weight: 700;
}

.weather-desc-block {
  display: flex;
  flex-direction: column;
}

.weather-icon-new {
  width: 50px;
  height: 50px;
  margin-left: -10px;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.2));
}

.temp-desc-new {
  font-size: 13px;
  text-transform: capitalize;
  opacity: 0.9;
}

.weather-right {
  display: flex;
  gap: 40px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.weather-detail-icon {
  font-size: 24px;
  opacity: 0.8;
}

.detail-text {
  display: flex;
  flex-direction: column;
}

.detail-val {
  font-size: 15px;
  font-weight: 600;
}

.detail-label {
  font-size: 11px;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.weather-loading {
  text-align: center;
  padding: 20px;
  opacity: 0.8;
}

@media (max-width: 1200px) {
  .content-cards-header {
    grid-template-columns: repeat(2, 1fr);
  }
  .cards-center-update {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .head-updates {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
  .updates-actions {
    flex-wrap: wrap;
  }
  .cards-center-update {
    grid-template-columns: 1fr;
  }
  .content-charts-section {
    grid-template-columns: 1fr;
  }
  .weather-content-new {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
  }
  .weather-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  .weather-location-info {
    border-right: none;
    padding-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 15px;
    width: 100%;
  }
  .weather-right {
    width: 100%;
    justify-content: space-between;
  }
}

.contentTerms {
  display: flex;
  height: 70vh;
  position: relative;
  flex-direction: column;
  align-items: center;
}

.titleTerms {
  font-size: 23px;
  text-align: center;
}

.textTerms {
  display: flex;
  flex-direction: column;
  text-align: justify;
  font-size: 12px;
  gap: 20px;
  font-weight: bold;
  overflow: auto;
  padding: 30px 40px 20px 40px;
}

.checkbox-wrapper-46 input[type="checkbox"] {
  display: none;
  visibility: hidden;
}

.checkbox-wrapper-46 .cbx {
  margin: auto;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}
.checkbox-wrapper-46 .cbx span {
  display: inline-block;
  vertical-align: middle;
  transform: translate3d(0, 0, 0);
}
.checkbox-wrapper-46 .cbx span:first-child {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  transform: scale(1);
  vertical-align: middle;
  border: 1px solid #9098a9;
  transition: all 0.2s ease;
}
.checkbox-wrapper-46 .cbx span:first-child svg {
  position: absolute;
  top: 3px;
  left: 2px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 16px;
  stroke-dashoffset: 16px;
  transition: all 0.3s ease;
  transition-delay: 0.1s;
  transform: translate3d(0, 0, 0);
}
.checkbox-wrapper-46 .cbx span:first-child:before {
  content: "";
  width: 100%;
  height: 100%;
  background: #506eec;
  display: block;
  transform: scale(0);
  opacity: 1;
  border-radius: 50%;
}
.checkbox-wrapper-46 .cbx span:last-child {
  padding-left: 8px;
}
.checkbox-wrapper-46 .cbx:hover span:first-child {
  border-color: #506eec;
}

.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child {
  background: #00486e;
  border-color: #506eec;
  animation: wave-46 0.4s ease;
}
.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child svg {
  stroke-dashoffset: 0;
}
.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child:before {
  transform: scale(3.5);
  opacity: 0;
  transition: all 0.6s ease;
}

@keyframes wave-46 {
  50% {
    transform: scale(0.9);
  }
}

.linkPdf {
  color: #007bff !important;
  text-decoration: underline;
  text-transform: uppercase;
}

.imgTerms {
  width: 275px;
  height: 150px;
  object-fit: contain;
}

.btnModalTerms {
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}
</style>

<style>
.update-details-modal .modal-dialog {
  max-width: 540px;
}

.update-details-modal .modal-content {
  border: 0;
  border-radius: 18px;
  box-shadow: 0 24px 65px rgba(11, 52, 29, 0.2);
}

.update-details-modal .modal-body {
  padding: 0;
}
</style>
